import { lazy } from "react";
import { ROLE } from "../utils/const";

// Route-level code splitting: keeps initial JS bundle small so first load is faster.
const Candidate = lazy(() => import("../pages/resume/Candidate"));
const EmployeeTimekeeping = lazy(() => import("../pages/timekeeping/employee.jsx"));
const TimesheetApproval = lazy(() =>
  import("../pages/timekeeping/timesheetApproval.jsx")
);
const ListSummary = lazy(() => import("../pages/summary/ListSummaryShadcn.jsx"));
const ListRegistration = lazy(() =>
  import("../pages/registration/ListRegistrationShadcn.jsx")
);
const Overview = lazy(() => import("../pages/overview/index"));
const Report = lazy(() => import("../pages/report/index.jsx"));
const Profile = lazy(() => import("../pages/profile/index.jsx"));
const ChangePassword = lazy(() => import("../pages/change-password/index.jsx"));
const ListUser = lazy(() => import("../pages/user/index.jsx"));
const ListDepartment = lazy(() => import("../pages/department/listDepartment.jsx"));
const DepartmentDetail = lazy(() => import("../pages/departmentDetail/index.jsx"));
const ListShift = lazy(() => import("../pages/shift/listShift.jsx"));
const ListPosition = lazy(() => import("../pages/position/listPosition.jsx"));
const Dashboard = lazy(() => import("../pages/dashboard/index.jsx"));
const StaffStatusPage = lazy(() => import("../pages/dashboard/StaffStatusPage.jsx"));
const ListStaff = lazy(() => import("../pages/staff/listStaff.jsx"));
const DepartmentManagement = lazy(() =>
  import("../pages/departmentManagement/index.jsx")
);
const CreateStaff = lazy(() => import("../pages/staff/createStaff.jsx"));
const EditStaff = lazy(() => import("../pages/staff/editStaff.jsx"));
const DefaultSystem = lazy(() => import("../pages/default-system/index.jsx"));
const LeaveManagement = lazy(() => import("../pages/leave-management/index.jsx"));
const CreateLeaveType = lazy(() =>
  import("../pages/leave-management/CreateLeaveType.jsx")
);
const EditLeaveType = lazy(() =>
  import("../pages/leave-management/EditLeaveType.jsx")
);
const SalaryComponent = lazy(() => import("../pages/salary-component/index.jsx"));
const ComponentCreatePage = lazy(() => import("../pages/salary-component/create.jsx"));
const SalaryTemplate = lazy(() => import("../pages/salary-template/index.jsx"));
const SalaryTemplateCreatePage = lazy(() => import("../pages/salary-template/create.jsx"));
const SalaryTemplateEditRedirect = lazy(() =>
  import("../pages/salary-template/SalaryTemplateEditRedirect.jsx")
);
const SalaryTemplateQueryRedirect = lazy(() =>
  import("../pages/salary-template/SalaryTemplateQueryRedirect.jsx")
);
const BonusList = lazy(() => import("../pages/payroll-data/bonus/index.jsx"));
const CreateBonus = lazy(() => import("../pages/payroll-data/bonus/create.jsx"));
const DetailBonus = lazy(() => import("../pages/payroll-data/bonus/detail.jsx"));
const DeductionList = lazy(() => import("../pages/payroll-data/deduction/index.jsx"));
const CreateDeduction = lazy(() => import("../pages/payroll-data/deduction/create.jsx"));
const DetailDeduction = lazy(() => import("../pages/payroll-data/deduction/detail.jsx"));
const ShiftChangeList = lazy(() =>
  import("../pages/payroll-data/shift-change/index.jsx")
);
const CreateShiftChange = lazy(() =>
  import("../pages/payroll-data/shift-change/create.jsx")
);
const DetailShiftChange = lazy(() =>
  import("../pages/payroll-data/shift-change/detail.jsx")
);
const OvertimeList = lazy(() => import("../pages/payroll-data/overtime/index.jsx"));
const DetailOvertime = lazy(() => import("../pages/payroll-data/overtime/detail.jsx"));
const CreateOvertime = lazy(() => import("../pages/payroll-data/overtime/create.jsx"));
const LeaveRequestList = lazy(() =>
  import("../pages/payroll-data/leave-request/index.jsx")
);
const CreateLeaveRequest = lazy(() =>
  import("../pages/payroll-data/leave-request/create.jsx")
);
const DetailLeaveRequest = lazy(() =>
  import("../pages/payroll-data/leave-request/detail.jsx")
);
const LateEarlyList = lazy(() => import("../pages/payroll-data/late-early/index.jsx"));
const CreateLateEarly = lazy(() => import("../pages/payroll-data/late-early/create.jsx"));
const DetailLateEarly = lazy(() => import("../pages/payroll-data/late-early/detail.jsx"));
const PayrollDataIndex = lazy(() => import("../pages/payroll-data/index.jsx"));
const AttendanceTimesheetPage = lazy(() =>
  import("../pages/payroll-data/attendance/index.jsx")
);
const PayrollPeriodList = lazy(() => import("../pages/payroll-calculation/index.jsx"));
const PayrollEmployeeRouteShell = lazy(() =>
  import("../pages/payroll-calculation/employees/route-shell.jsx")
);
const PaymentPeriodList = lazy(() => import("../pages/payroll-payment/index.jsx"));
const PaymentPeriodRedirect = lazy(() => import("../pages/payroll-payment/redirect.jsx"));
const PaymentDetailList = lazy(() =>
  import("../pages/payroll-payment/employees/index.jsx")
);
const SettingsIndex = lazy(() => import("../pages/settings/index.jsx"));
const AiCameraSettingsPage = lazy(() => import("../pages/settings/ai-camera/index.jsx"));
const OfficeListPage = lazy(() => import("../pages/settings/offices/index.jsx"));
const SelfServiceProfile = lazy(() => import("../pages/self-service/profile/index.jsx"));
const SelfServicePayroll = lazy(() => import("../pages/self-service/payroll/index.jsx"));
const SelfServiceSalaryComponents = lazy(() =>
  import("../pages/self-service/salary-components/index.jsx")
);
const SelfServiceRequests = lazy(() =>
  import("../pages/self-service/requests/index.jsx")
);
const UserManagement = lazy(() => import("../pages/settings/user-management/index.jsx"));
const ChangelogPage = lazy(() => import("../pages/settings/changelog/index.jsx"));
const NotificationsPage = lazy(() => import("../pages/notifications/index.jsx"));
const GroupBookingPage = lazy(() => import("../pages/group-booking/index.jsx"));

/**
 * Route config schema.
 *
 * Legacy route guarding (current behavior) uses numeric role IDs from cookie `roles`.
 *
 * RBAC v2 (planned): routes can declare `permissions` (permission names from backend, e.g. "system.user")
 * and optional `permissionsMode` for evaluation strategy.
 *
 * @typedef {Object} AppRoute
 * @property {string|string[]} path
 * @property {*} component
 * @property {number[]} roles
 * @property {boolean=} exact
 * @property {string[]=} permissions Permission names (RBAC) required to access the route.
 * @property {"any"|"all"=} permissionsMode Defaults to "any" (OR). Use "all" for AND.
 */

// export
const routes = [
  // Dashboard (Home)
  {
    path: ["/", "/dashboard"],
    component: Dashboard,
    roles: [...Object.values(ROLE)],
    permissions: ["employee.view", "attendance.view", "payroll.view"],
    permissionsMode: "any",
    exact: true,
  },
  //Resume
  {
    path: "/summary",
    component: ListSummary,
    roles: [...Object.values(ROLE)],
    // Timesheet summary is protected by `attendance.view` on backend (TimeSheetController).
    permissions: ["attendance.view"],
  },
  {
    path: "/candidate/:id",
    component: Candidate,
    roles: [...Object.values(ROLE)],
    // Legacy resume/recruitment screens (permission seed added; backend module still legacy/partial).
    permissions: ["recruitment.view"],
  },
  // Timekeeping - Staff Status (main timekeeping page)
  {
    path: "/timekeeping",
    component: StaffStatusPage,
    roles: [...Object.values(ROLE)],
    // Staff status timekeeping view should be guarded by attendance permissions.
    permissions: ["attendance.view", "attendance.approve"],
    permissionsMode: "any",
    exact: true,
  },
  {
    path: "/timekeeping/attendance",
    component: AttendanceTimesheetPage,
    roles: [...Object.values(ROLE)],
    permissions: ["attendance.view"],
  },
  // Timekeeping Detail
  {
    path: "/timekeeping/detail/:employee_id",
    component: EmployeeTimekeeping,
    roles: [...Object.values(ROLE)],
    permissions: ["attendance.view"],
  },
  // Timesheet Approval
  {
    path: "/timekeeping/approval",
    component: TimesheetApproval,
    roles: [...Object.values(ROLE)],
    permissions: ["attendance.view", "attendance.approve"],
    permissionsMode: "all",
  },
  {
    path: "/registration",
    component: ListRegistration,
    roles: [...Object.values(ROLE)],
    // Uses staff list + working plan endpoints.
    permissions: ["employee.view"],
  },
  {
    path: "/overview",
    component: Overview,
    roles: [...Object.values(ROLE)],
    permissions: ["attendance.view", "employee.view"],
    permissionsMode: "any",
  },
  {
    path: "/group-booking-demo",
    component: GroupBookingPage,
    roles: [...Object.values(ROLE)],
    permissions: [],
    exact: true,
  },
  {
    path: "/report",
    component: Report,
    roles: [...Object.values(ROLE)],
    permissions: ["report.attendance", "report.employee", "report.payroll", "report.export"],
    permissionsMode: "any",
  },
  {
    path: "/profile",
    component: Profile,
    roles: [...Object.values(ROLE)],
    permissions: [], // Own profile (auth-only)
  },
  {
    path: "/change-password",
    component: ChangePassword,
    roles: [...Object.values(ROLE)],
    permissions: [], // Own password (auth-only)
  },
  {
    path: "/user",
    component: ListUser,
    roles: [...Object.values(ROLE)],
    permissions: ["system.user.view"],
  },
  {
    path: "/department",
    component: ListDepartment,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.department.view"],
  },
  {
    path: "/department/:id",
    component: DepartmentDetail,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.department.view"],
  },
  {
    path: "/shift",
    component: ListShift,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.shift.view", "setting.shift"],
    permissionsMode: "any",
  },

  // Staff routes
  {
    path: "/staff",
    component: ListStaff,
    roles: [...Object.values(ROLE)],
    permissions: [
      "employee.base.view",
      "employee.salary.view",
      "employee.insurance_tax.view",
      "employee.view",
    ],
    permissionsMode: "any",
  },
  {
    path: "/staff/create",
    component: CreateStaff,
    roles: [...Object.values(ROLE)],
    permissions: ["employee.base.create", "employee.create"],
    permissionsMode: "any",
  },
  {
    path: "/staff/:id",
    component: EditStaff,
    roles: [...Object.values(ROLE)],
    permissions: [
      "employee.base.view",
      "employee.salary.view",
      "employee.insurance_tax.view",
      "employee.view",
    ],
    permissionsMode: "any",
  },
  {
    path: "/staff/:id/history/:historyId",
    component: EditStaff,
    // component: HistoryStaff,
    roles: [...Object.values(ROLE)],
    permissions: [
      "employee.base.view",
      "employee.salary.view",
      "employee.insurance_tax.view",
      "employee.view",
    ],
    permissionsMode: "any",
  },
  {
    path: "/payroll-data",
    component: PayrollDataIndex,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll.view", "attendance.view", "leave.view"],
    permissionsMode: "any",
  },
  {
    path: "/payroll-data/attendance",
    component: AttendanceTimesheetPage,
    roles: [...Object.values(ROLE)],
    permissions: ["attendance.view"],
  },
  {
    path: "/payroll-data/bonus-list",
    component: BonusList,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.bonus-list.view", "payroll.view"],
  },
  {
    path: "/payroll-data/bonus/create",
    component: CreateBonus,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.bonus-list.create", "payroll.create"],
  },
  {
    path: "/payroll-data/bonus/:id",
    component: DetailBonus,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.bonus-list.view", "payroll.view"],
  },
  // router deduction
  {
    path: "/payroll-data/deduction-list",
    component: DeductionList,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.deduction-list.view", "payroll.view"],
  },
  {
    path: "/payroll-data/deduction/create",
    component: CreateDeduction,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.deduction-list.create", "payroll.create"],
  },
  {
    path: "/payroll-data/deduction/:id",
    component: DetailDeduction,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-data.deduction-list.view", "payroll.view"],
  },
  // router shift change
  {
    path: "/payroll-data/shift-change",
    component: ShiftChangeList,
    roles: [...Object.values(ROLE)],
    permissions: ["shift_change.view"],
  },
  {
    path: "/payroll-data/shift-change/create",
    component: CreateShiftChange,
    roles: [...Object.values(ROLE)],
    permissions: ["shift_change.create"],
  },
  {
    path: "/payroll-data/shift-change/:id",
    component: DetailShiftChange,
    roles: [...Object.values(ROLE)],
    permissions: ["shift_change.view"],
  },
  //
  // router overtime
  {
    path: "/payroll-data/overtime",
    component: OvertimeList,
    roles: [...Object.values(ROLE)],
    permissions: ["overtime.view"],
  },
  {
    path: "/payroll-data/overtime/create",
    component: CreateOvertime,
    roles: [...Object.values(ROLE)],
    permissions: ["overtime.create"],
  },
  {
    path: "/payroll-data/overtime/:id",
    component: DetailOvertime,
    roles: [...Object.values(ROLE)],
    permissions: ["overtime.view"],
  },
  // router leave request
  {
    path: "/payroll-data/leave-request",
    component: LeaveRequestList,
    roles: [...Object.values(ROLE)],
    permissions: ["leave.view"],
  },
  {
    path: "/payroll-data/leave-request/create",
    component: CreateLeaveRequest,
    roles: [...Object.values(ROLE)],
    permissions: ["leave.create"],
  },
  {
    path: "/payroll-data/leave-request/:id",
    component: DetailLeaveRequest,
    roles: [...Object.values(ROLE)],
    permissions: ["leave.view"],
  },
  // router late-early
  {
    path: "/payroll-data/late-early",
    component: LateEarlyList,
    roles: [...Object.values(ROLE)],
    permissions: ["late_early.view"],
  },
  {
    path: "/payroll-data/late-early/create",
    component: CreateLateEarly,
    roles: [...Object.values(ROLE)],
    permissions: ["late_early.create"],
  },
  {
    path: "/payroll-data/late-early/:id",
    component: DetailLateEarly,
    roles: [...Object.values(ROLE)],
    permissions: ["late_early.view"],
  },
  //
  {
    path: "/payroll",
    // Entry point for payroll users (keep legacy /payroll path, reuse payroll calculation list).
    component: PayrollPeriodList,
    roles: [...Object.values(ROLE)],
    permissions: ["payroll-calculation.view", "payroll.view"],
    exact: true,
  },
  // Payroll Calculation
  {
    path: "/payroll-calculation",
    component: PayrollPeriodList,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE, ROLE.DIRECTOR],
    permissions: ["payroll-calculation.view", "payroll.view"],
    exact: true,
  },
  {
    path: [
      "/payroll-calculation/:periodId/employees",
      "/payroll-calculation/:periodId/employee/:payrollId",
    ],
    component: PayrollEmployeeRouteShell,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE, ROLE.DIRECTOR],
    permissions: ["payroll-calculation.view", "payroll.view"],
    exact: true,
  },
  // Payroll Payment
  {
    path: "/payroll-payment",
    component: PaymentPeriodList,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE, ROLE.DIRECTOR],
    permissions: ["payroll-payment.view", "payroll.view"],
    exact: true,
  },
  {
    path: "/payroll-payment/:periodId",
    component: PaymentPeriodRedirect,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE, ROLE.DIRECTOR],
    permissions: ["payroll-payment.view", "payroll.view"],
    exact: true,
  },
  {
    path: "/payroll-payment/:periodId/employees",
    component: PaymentDetailList,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE, ROLE.DIRECTOR],
    permissions: ["payroll-payment.view", "payroll.view"],
    exact: true,
  },
  {
    path: "/settings",
    component: SettingsIndex,
    roles: [...Object.values(ROLE)],
    permissions: [
      "salary.view",
      "salary.update",
      "system.config",
      "setting.department.view",
      "setting.position.view",
      "setting.shift.view",
      "setting.leave_type.view",
      "setting.salary_component.view",
      "setting.salary_template.view",
      "setting.salary_template.create",
      "setting.salary_template.update",
      "setting.salary_template.delete",
      "setting.ai_camera",
      "system.user",
      "system.role",
      "system.permission",
      "system.user.view",
      "system.role.view",
      "system.permission.view",
    ],
    permissionsMode: "any",
  },
  {
    path: "/settings/departments",
    component: ListDepartment,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.department.view"],
  },
  {
    path: "/settings/departments/:id",
    component: DepartmentManagement,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.department.view"],
  },
  {
    path: "/settings/positions",
    component: ListPosition,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.position.view"],
  },
  {
    path: "/settings/offices",
    component: OfficeListPage,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.office.view"],
  },
  {
    path: "/settings/default-system",
    component: DefaultSystem,
    roles: [...Object.values(ROLE)],
    permissions: ["salary.view", "salary.update", "system.config"],
    permissionsMode: "any",
  },
  {
    path: "/settings/ai-camera",
    component: AiCameraSettingsPage,
    roles: [...Object.values(ROLE)],
    permissions: ["system.config", "setting.ai_camera"],
    permissionsMode: "any",
  },
  {
    path: "/settings/leave-management",
    component: LeaveManagement,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.leave_type.view"],
  },
  {
    path: "/settings/leave-management/leave-type/create",
    component: CreateLeaveType,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.leave_type.create"],
  },
  {
    path: "/settings/leave-management/leave-type/:id",
    component: EditLeaveType,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.leave_type.view"],
  },
  {
    path: "/settings/salary-component/create",
    component: ComponentCreatePage,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_component.create"],
  },
  {
    path: "/settings/salary-component",
    component: SalaryComponent,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_component.view"],
  },
  {
    path: "/settings/salary-template",
    component: SalaryTemplate,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.view"],
  },
  {
    path: "/settings/salary-template/create",
    component: SalaryTemplateCreatePage,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.create"],
  },
  // Backward compatible: query-based edit URL (used previously).
  {
    path: "/settings/salary-template/Update-salary-template",
    component: SalaryTemplateQueryRedirect,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.update"],
  },
  // Friendly alias (optional): keep a lowercase `update/:id` route and redirect to the canonical label.
  {
    path: "/settings/salary-template/update/:id",
    component: SalaryTemplateEditRedirect,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.update"],
  },
  {
    path: "/settings/salary-template/Update-salary-template/:slug",
    component: SalaryTemplateCreatePage,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.update"],
  },
  // Backward compatible: redirect legacy edit URL to the new canonical one.
  {
    path: "/settings/salary-template/:id",
    component: SalaryTemplateEditRedirect,
    roles: [...Object.values(ROLE)],
    permissions: ["setting.salary_template.update"],
  },
  {
    path: "/settings/user-management",
    component: UserManagement,
    roles: [ROLE.ICT_ROLE, ROLE.HR_ROLE],
    permissions: ["system.user.view", "system.role.view", "system.permission.view"],
    permissionsMode: "any",
  },
  {
    path: "/settings/changelog",
    component: ChangelogPage,
    roles: [...Object.values(ROLE)],
    permissions: [], // Viewable by all authenticated users
  },
  {
    path: "/notifications",
    component: NotificationsPage,
    roles: [...Object.values(ROLE)],
    permissions: ["notification.view"], // Own notifications
  },
  // Self-Service Portal
  {
    path: "/self-service/profile",
    component: SelfServiceProfile,
    roles: [...Object.values(ROLE)],
    permissions: ["self_service.view"],
  },
  {
    path: "/self-service/payroll",
    component: SelfServicePayroll,
    roles: [...Object.values(ROLE)],
    permissions: ["self_service.view"],
  },
  {
    path: "/self-service/salary-components",
    component: SelfServiceSalaryComponents,
    roles: [...Object.values(ROLE)],
    permissions: ["self_service.view"],
  },
  {
    path: "/self-service/requests",
    component: SelfServiceRequests,
    roles: [...Object.values(ROLE)],
    permissions: ["self_service.view"],
  },
];

export default routes;
